import { render, staticRenderFns } from "./MySwipe.vue?vue&type=template&id=ecad7bfe&scoped=true"
import script from "./MySwipe.vue?vue&type=script&lang=js"
export * from "./MySwipe.vue?vue&type=script&lang=js"
import style0 from "./MySwipe.vue?vue&type=style&index=0&id=ecad7bfe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecad7bfe",
  null
  
)

export default component.exports